import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';

export const TodoPlanner: NavigationWrapper = {
  title: 'Aufgabenplaner',
  route: ShiveRoutes.TodoPlanner,
};
